import type { GQL_ID, NestedFilter } from '@@partner:graphql/types'

import React, { useMemo, useState } from 'react'
import { CheckPicker } from 'rsuite'
import { useFetchAllMarketingLabels } from '@@partner:graphql/query/labels/allMarketingLabels.gql'
import { renderLazyPickerMenu } from '@components/common/pickers'

export interface MarketingLabelsFilterProps {
  value: GQL_ID[]
  onChange: (value: GQL_ID[]) => void
  placeholder?: string
}

const defaultFilter: NestedFilter = {
  fields: [ 'name' ],
  op: 'unwrap'
}

export default function MarketingLabelsFilter ({
  value,
  onChange,
  placeholder = 'Маркетинговые лейблы'
}: MarketingLabelsFilterProps) {
  const [ filter, setFilter ] = useState<NestedFilter>(defaultFilter)

  const { data, loading } = useFetchAllMarketingLabels({
    filter,
    pager: { page: 1, limit: 100 }
  })

  const handleSearchByName = (text: string) => {
    if (!text) {
      setFilter(defaultFilter)
      return
    }
    setFilter({
      or: [
        {
          fields: [ 'name' ],
          op: 'starts_with',
          value: [ text ]
        }
      ]
    })
  }

  const options = useMemo(() => {
    if (!data?.allMarketingLabels?.edges) return []
    return data.allMarketingLabels.edges.map(label => ({
      label: label.name,
      value: label.id
    }))
  }, [ data ])

  return (
    <CheckPicker
      data={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      onSearch={handleSearchByName}
      renderMenu={renderLazyPickerMenu(loading, data)}
      block
    />
  )
}
